import * as React from 'reactn';
import { addCallback } from 'reactn';
import {
    ArrayUtil,
    PaperComponent,
    MenuButtonComponent,
    base,
    SelectItem,
    StringUtil,
    DialogUtil, IBaseProps, BaseColor, IconButtonComponent, BaseIcon, ComponentFactory, DateUtil
} from 'oca-lib-web'
import MoreVert from "@mui/icons-material/MoreVert";
import LinearProgress from '@mui/material/LinearProgress';
import {createRef} from "react";
import analyticsLogo from "../image/analytics_logo_large.png";
import Constants from "../util/Constants";
import arrowUp from "../image/arrow_up.png";
import arrowDown from "../image/arrow_down.png";
import Sidebar from "../component/Sidebar";
import GraphSettingsDialog from "../component/GraphDataDialog";
import AnalyticsEngine from "../data/AnalyticsEngine";
import GraphUtil from "../util/GraphUtil";
import AnalyticsTypes from "../util/AnalyticsTypes";
import ExportUtil from "../util/ExportUtil";
import SelectedValuesDialog from "../component/SelectedValuesDialog";
import DashboardDateUtil from "../util/DashboardDateUtil";
import 'react-bulma-components/dist/react-bulma-components.min.css';
import { Level } from 'react-bulma-components';
import CacheSettings from "../util/CacheSettings";
import PageSettingsDialog from "../component/PageSettingsDialog";
import ReportSettingsDialog from "../component/ReportSettingsDialog";
import GraphOptionsDialog from "../component/GraphOptionsDialog";
import GraphFilterDialog from "../component/GraphFilterDialog";
import BaseDataSource from "../data/BaseDataSource";
import ExportDialog from "../component/ExportDialog";
import CustomDateDialog from "../component/CustomDateDialog";
import ReportUtil from "../util/ReportUtil";
import Styles from "../style/Styles";
import DataMappingDialog from "../component/DataMappingDialog";
import DataMappingUtil from "../util/DataMappingUtil";

interface IState {
    componentFactory:ComponentFactory,
    dialogs:Array<any>,
    selectedProject?: ProjectModel,
    report: any,
    timeInterval: TimeInterval,
    projectOptions: Array<SelectItem>,
    analyticsDatasets:{},
    currentPage?:string,
    pageOptions:Array<string>,
    dataMappings:Array<DataMapping>,
    dateOptionValue?: string,
    dataLoaded: boolean,
}

class DashboardPage extends React.PureComponent<IBaseProps, IState> {
    public dataMappingDialog = createRef<any>();
    public graphSettingsDialog = createRef<any>();
    public graphOptionsDialog = createRef<any>();
    public graphFilterDialog = createRef<any>();
    public pageSettingsDialog = createRef<any>();
    public selectedValuesDialog = createRef<any>();
    public reportSettingsDialog = createRef<any>();
    public exportDialog = createRef<any>();
    public customDateDialog = createRef<any>();

    constructor() {
        super();

        let componentFactory = new ComponentFactory(Styles.default);
        componentFactory.addDefaultBinding(null, null, {dateOptionValue: CacheSettings.getCurrentTimeInterval()});
        componentFactory.setHandleUpdateCallback(this.propertyChanged.bind(this));
        let dialogs = [
            <DataMappingDialog {...componentFactory.renderDialogProps("Data Mapping", "Save", this.dataMappingDialogCallback.bind(this), this.dataMappingDialog)} />,
            <GraphSettingsDialog {...componentFactory.renderDialogProps("Graph Data", "Save", this.graphSettingsDialogCallback.bind(this), this.graphSettingsDialog, "md")} />,
            <GraphOptionsDialog {...componentFactory.renderDialogProps("Graph Options", "Save", this.graphSettingsDialogCallback.bind(this), this.graphOptionsDialog)} />,
            <GraphFilterDialog {...componentFactory.renderDialogProps("Graph Filters", "Save", this.graphSettingsDialogCallback.bind(this), this.graphFilterDialog)} />,
            <SelectedValuesDialog {...componentFactory.renderDialogProps("Selected Values", "Save", null, this.selectedValuesDialog, "xl")} />,
            <ReportSettingsDialog {...componentFactory.renderDialogProps("Report Settings", "Save", this.reportSettingsDialogCallback.bind(this), this.reportSettingsDialog, "md")} />,
            <PageSettingsDialog {...componentFactory.renderDialogProps("Page Settings", "Save", this.pageSettingsDialogCallback.bind(this), this.pageSettingsDialog, "md")} />,
            <ExportDialog {...componentFactory.renderDialogProps("Download", "Download", this.exportDialogCallback.bind(this), this.exportDialog)} />,
            <CustomDateDialog {...componentFactory.renderDialogProps("Select Dates", "Save", this.customDialogCallback.bind(this), this.customDateDialog)} />
        ];

        this.state = {
            componentFactory: componentFactory,
            dialogs:dialogs,
            dateOptionValue: CacheSettings.getCurrentTimeInterval(),
            projectOptions: [],
            pageOptions: [],
            dataMappings: [],
            analyticsDatasets: {},
            report: {},
            timeInterval: DashboardDateUtil.getTimeInterval(),
            dataLoaded: false
        };
    }

    /*
     * Application lifecycle methods
     */

    async componentDidMount() {
        console.log("DashboardPage - componentDidMount");
        //LocalCache.removeLocal(Constants.CACHE_DATE);

        addCallback(global => {
            console.log("callback")
            this.setupDashboard();
            return null;
        });

        this.setupDashboard();
    }

    /*
     * Load project methods
     */

    async setupDashboard() {
        if (!this.global.isGlobalLoaded) {
            console.log("global not loaded")
            return;
        }
        console.log("global loaded")

        this.loadProjectOptions();
        var projectId = CacheSettings.getCurrentProject();
        if (!projectId) {
            //let projects = await this.global.data.getProjectsForAdmin();
            let projects = await this.global.dataManager.get("getProjectsForAdmin");
            console.log(projects);
            ArrayUtil.sort(projects, "projectName");
            projectId = projects.length > 0 ? projects[0].id : null;
        }
        if (projectId) {
            console.log("About to load project - " + projectId);
            //CacheSettings.clearAnalyticsSettings(projectId);
            //CacheSettings.clearCurrentPage(projectId);
            this.loadProject(projectId);
        }
    }

    propertyChanged(value:any, key:string) {
        console.log("key: " + key + " value: " + value);
        if (key == "selectedProjectId") {
            this.onProjectSelected(value);
        } else if (key == "dateOptionValue") {
            this.dateIntervalSelected(value);
        }
    }

    /*
     * Project / Pages
     */

    async loadProjectOptions() {
        let projects = await this.global.dataManager.get("getProjectsForAdmin");
        ArrayUtil.sort(projects, "projectName");
        let projectOptions = SelectItem.fromArray(projects, "id", "projectName");
        this.setState({projectOptions:projectOptions});
    }

    // TODO: Reset project not working
    async loadProject(projectId:string) {
        let project = await this.global.dataManager.get("getProject", projectId);
        let report = await ReportUtil.getReport(projectId);
        console.log("LOADING REPORT JSON");
        console.log(report);

        project.reportJson = JSON.parse(project.reportJson);
        console.log("About to load project for " + project.projectName + " with time interval " + JSON.stringify(this.state.timeInterval));

        let dataMappings = await DataMappingUtil.getDataMappings(projectId);
        this.state.componentFactory.getDefaultBinding().setProperty("selectedProjectId", projectId);
        this.forceUpdate();

        this.setState({selectedProject:project, currentPage:CacheSettings.getCurrentPage(), dataMappings:dataMappings, report:report}, async function(this:DashboardPage) {
            this.loadPagesForProject(projectId);
            // TODO: This needs to be done in change project
            //await BaseDataSource.clearDataCache(this.state.selectedProject); // eventually we should preface cache with data id
            await BaseDataSource.loadData(project, this.state.timeInterval);
            let analyticsDatasets = this.generateDatasets();
            this.setState({analyticsDatasets:analyticsDatasets, dataLoaded:true}, function(this:DashboardPage) {
                console.log("finished getting all data");
                //this.forceUpdate();
            }.bind(this));
        }.bind(this));
    }

    loadPagesForProject(projectId:string) {
        //let analyticsSettings:AnalyticsSettings = LocalCache.getLocal(projectId + "_" + Constants.CACHE_ANALYTICS_SETTINGS) ? JSON.parse(LocalCache.getLocal(projectId + "_" + Constants.CACHE_ANALYTICS_SETTINGS)) : {};

        let pageOptions:Array<string> = [];
        let pages = ReportUtil.getAllReportPages(this.state.report);
        console.log("loadPagesForProject");
        console.log(pages);

        for (let page of pages) {
            pageOptions.push(page.pageTitle);
        }
        pageOptions.push("Add Page");
        this.setState({pageOptions:pageOptions});
    }


    generateDatasets(refreshAll:boolean = false) {
        console.log("start generateDatasets");
        //if (!this.state.reportSettings || !this.state.reportSettings.pages) return [];
        //let pages = ReportUtil.getAllReportPages(this.state.report);
        //if (pages.length == 0) return [];
        let page = ReportUtil.getCurrentReportPage(this.state.report);
        if (!page) return [];

        let analyticsDatasets = !refreshAll ? (this.state.analyticsDatasets || {}) : {};
        let graphSettings:Array<GraphSettings> = [];
        for (let graphSettingItem of page.graphs) {
            graphSettings.push(graphSettingItem);
        }

        for (let graphSettingItem of graphSettings) {
            let currentGraphKey = GraphUtil.getGraphKey(graphSettingItem, Constants.CURRENT);
            if (!analyticsDatasets[currentGraphKey]) {
                analyticsDatasets[currentGraphKey] = AnalyticsEngine.getDataset(graphSettingItem, this.state.timeInterval);
            }
            if (graphSettingItem.showPercentIncrease) {
                let previousGraphKey = GraphUtil.getGraphKey(graphSettingItem, Constants.PREVIOUS);
                if (!analyticsDatasets[previousGraphKey]) {
                    analyticsDatasets[previousGraphKey] = AnalyticsEngine.getDataset(graphSettingItem, DashboardDateUtil.getPreviousTimeInterval());
                }
            }
        }
        console.log("Loaded all datasets");
        console.log(analyticsDatasets);

        return analyticsDatasets;
    }

    /*
     * Project / Date / Options selections
     */

    async onProjectSelected(value:string) {
        this.setState({dataLoaded:false}, async function(this:DashboardPage) {
            await BaseDataSource.clearDataCache(this.state.selectedProject);
            let analyticsDatasets = this.generateDatasets();
            this.setState({analyticsDatasets:analyticsDatasets}, function(this:DashboardPage) {
                CacheSettings.saveCurrentProject(value);
                this.loadProject(value);
            }.bind(this));
        }.bind(this));
    };

    async onPageSelected(index:number) {
        let pageName = this.state.pageOptions[index];
        if (pageName == "Add Page") {
            //let reportSettings = this.state.reportSettings;
            //let reportJson = this.state.selectedProject.reportJson;
            let report = this.state.report;
            if (!report || !report.pages) {
                report = {
                    pages: []
                };
            }
            let pageSettings:PageSettings = {
                id: StringUtil.uuid(),
                pageTitle: "Page " + (report.pages ? report.pages.length + 1 : 1),
                graphs: []
            }
            report.pages.push(pageSettings);

            //let project = await GraphUtil.updateReportJson(reportJson, this.state.selectedProject);
            await ReportUtil.saveReport(this.state.selectedProject.id, report)
            CacheSettings.saveCurrentPage(pageSettings.id);

            this.setState({report:report, currentPage:pageSettings.id}, function(this:DashboardPage) {
                this.loadPagesForProject(this.state.selectedProject.id);
            }.bind(this));

        } else {
            let pages = ReportUtil.getAllReportPages(this.state.report)
            for (let page of pages) {
                if (page.pageTitle == pageName) {
                    CacheSettings.saveCurrentPage(page.id);
                    let analyticsDatasets = this.generateDatasets();
                    //let pageSettings = GraphUtil.getAnalyticsPage(page.id, this.state.reportSettings);
                    this.setState({analyticsDatasets:analyticsDatasets, currentPage:page.id});
                }
            }
        }
    }

    dateIntervalSelected(value:string) {
        this.state.componentFactory.getDefaultBinding().setProperty("dateOptionValue", value);
        this.forceUpdate();

        CacheSettings.saveCurrentTimeInterval(value);
        this.setState({dateOptionValue:value, timeInterval:DashboardDateUtil.getTimeInterval(), dataLoaded:false}, async function(this:DashboardPage) {
            if (value == "custom") {
                DialogUtil.open(this.customDateDialog.current);
            } else {
                await BaseDataSource.clearDataCache(this.state.selectedProject);
                await BaseDataSource.loadData(this.state.selectedProject, this.state.timeInterval);
                let analyticsDatasets = this.generateDatasets(true);
                //await this.refreshDatasets(true);
                /*let analyticsDatasets = this.generateDatasets();
                this.setState({analyticsDatasets:analyticsDatasets}, function(this:DashboardPage) {
                    this.loadProject(this.state.selectedProject.id);
                });*/
                //await this.loadProject(this.state.selectedProject.id);
                this.setState({analyticsDatasets:analyticsDatasets, dataLoaded:true}, function(this:DashboardPage) {
                    //this.loadProject(this.state.selectedProject.id);
                }.bind(this))

            }
        }.bind(this));
    }

    /*
     * Callback methods
     */

    async dataMappingDialogCallback(dataMappings:Array<DataMapping>) {
        this.setState({dataMappings:dataMappings});
    }

    async graphSettingsDialogCallback(graphSettings:GraphSettings) {
        console.log("graphSettingsDialogCallback");
        //let reportSettings = this.state.reportSettings;
        //let reportJson = this.state.selectedProject.reportJson;
        let report = this.state.report;
        for (var i=0; i<report.pages.length; i++) {
            for (let j=0; j<report.pages[i].graphs.length; j++) {
                if (report.pages[i].graphs[j].id == graphSettings.id) {
                    console.log("updating graph settings");
                    //console.log(graphSettings);
                    report.pages[i].graphs[j] = graphSettings;
                }
            }
        }

        //let project = await GraphUtil.updateReportJson(reportJson, this.state.selectedProject);
        await ReportUtil.saveReport(this.state.selectedProject.id, report);

        //await this.refreshDatasets();
        // TODO: eventually determine if the change is something that requires the datasets to be regenerated
        let analyticsDatasets = this.generateDatasets(true);
        this.setState({report:report, analyticsDatasets:analyticsDatasets}, function(this:DashboardPage) {
            this.forceUpdate();
        }.bind(this));
    }

    async customDialogCallback(customDate:any) {
        let startDate = DateUtil.format(customDate.startDate, "YYYYMMDD");
        let endDate = DateUtil.format(customDate.endDate, "YYYYMMDD");
        CacheSettings.setCustomDate(startDate + "," + endDate);
        console.log(customDate);

        await BaseDataSource.clearDataCache(this.state.selectedProject);
        await BaseDataSource.loadData(this.state.selectedProject, this.state.timeInterval);
        let analyticsDatasets = this.generateDatasets(true);

        this.setState({analyticsDatasets:analyticsDatasets, timeInterval:DashboardDateUtil.getTimeInterval()}, function(this:DashboardPage) {
            this.loadProject(this.state.selectedProject.id);
        }.bind(this));
    }

    async exportDialogCallback() {}

    async pageSettingsDialogCallback(pageSettings:PageSettings) {
        console.log("pageDialogCallback");
        console.log(pageSettings);
        //let reportSettings = this.state.reportSettings;
        //let pages = GraphUtil.getAllPages(this.state.selectedProject);
        //let reportJson = this.state.selectedProject.reportJson;
        let report = this.state.report;
        for (var i=0; i<report.pages.length; i++) {
            if (report.pages[i] == pageSettings.id) {
                report.pages[i] = pageSettings;
            }
        }
        //let project = await GraphUtil.updateReportJson(reportJson, this.state.selectedProject);
        await ReportUtil.saveReport(this.state.selectedProject.id, report);

        //CacheSettings.saveCurrentAnalyticsSettings(reportSettings);
        this.loadPagesForProject(this.state.selectedProject.id);
        let analyticsDatasets = this.generateDatasets();
        this.setState({report:report, analyticsDatasets:analyticsDatasets}, function(this:DashboardPage) {
            this.forceUpdate();
        }.bind(this));
    }

    async reportSettingsDialogCallback(reportSettings:ReportSettings) {
        console.log("reportSettingsDialogCallback");
        console.log(reportSettings);

        //let project = await GraphUtil.updateReportJson(reportSettings, this.state.selectedProject);
        await ReportUtil.saveReport(this.state.selectedProject.id, reportSettings);
        let analyticsDatasets = this.generateDatasets();
        this.setState({report:reportSettings, analyticsDatasets:analyticsDatasets}, function(this:DashboardPage) {
            this.loadPagesForProject(this.state.selectedProject.id);
            this.onPageSelected(0);
            this.forceUpdate();
        }.bind(this));
    }

    /*
     * Events
     */

    async moreActionsTapped(index:number) {
        console.log(index);
        if (index == 0) { // download
            //Dashboards.downloadReport(this.state.selectedProject.id, this.state.appList, this.state.usageType, this.state.timeInterval, this.state.analyticsSettings)
            //ExportUtil.downloadReport(this.state.selectedProject.reportJson, this.state.timeInterval, this.state.selectedProject);
            DialogUtil.open(this.exportDialog.current, this.state.report);
        } else if (index == 1) { // duplicate
            this.duplicatePage();
        } else if (index == 2) { // delete
            this.props.base.alert("Confirm Delete", "Are you sure you want to delete this page? This action cannot be undone.", this.deletePage.bind(this), null)
        } else if (index == 3) { // data mapping
            DialogUtil.open(this.dataMappingDialog.current, this.state.selectedProject.id);
        } else if (index == 4) { // settings
            //DialogUtil.open(this.reportSettingsDialog.current, this.state.selectedProject.reportJson);
            DialogUtil.open(this.reportSettingsDialog.current, this.state.report);
        }
    }

    optionsTapped(item:GraphSettings, index:number) {
        console.log("optionsTapped " + item + " : " + index);
        if (index == 0) { // data
            DialogUtil.open(this.graphSettingsDialog.current, item);
        } else if (index == 1) { // options
            DialogUtil.open(this.graphOptionsDialog.current, item);
        } else if (index == 2) { // filter
            DialogUtil.open(this.graphFilterDialog.current, item);
        } else if (index == 3) { // export
            ExportUtil.exportData(item, this.state.timeInterval);
        }
    }

    async deletePage() {
        let report = this.state.report;
        console.log(report.pages);
        let currentPage = ReportUtil.getCurrentReportPage(report);
        console.log(currentPage);
        ArrayUtil.deleteItemByKey(currentPage, "id", report.pages);
        console.log(report.pages);

        await ReportUtil.saveReport(this.state.selectedProject.id, report)
        CacheSettings.saveCurrentPage(report.pages[0].id);

        this.setState({report:report, currentPage:report.pages[0].id}, function(this:DashboardPage) {
            this.loadPagesForProject(this.state.selectedProject.id);
        }.bind(this));
    }

    duplicatePage() {
        let currentReportPage:PageSettings = ReportUtil.getCurrentReportPage(this.state.report);
        let duplicatePage = Object.assign({}, currentReportPage);
        duplicatePage.id = StringUtil.uuid();
        //duplicatePage.pageTitle = "Page " + ReportUtil.getAllReportPages(this.state.report).length;
        duplicatePage.pageTitle = currentReportPage.pageTitle + " (1)";
        //duplicatePage.pageDescription = null;
        let duplicateGraphs = [];
        for (let graph of duplicatePage.graphs) {
            let duplicateGraph = Object.assign({}, graph);
            duplicateGraph.id = StringUtil.uuid();
            if (duplicateGraph.filters) {
                let duplicateFilters = [];
                for (let filter of duplicateGraph.filters) {
                    let duplicateFilter = Object.assign({}, filter);
                    duplicateFilters.push(duplicateFilter);
                }
                duplicateGraph.filters = duplicateFilters;
            }
            duplicateGraphs.push(duplicateGraph);
        }
        duplicatePage.graphs = duplicateGraphs;
        //let reportSettings = this.state.reportSettings;
        //let reportJson = this.state.selectedProject.reportJson;
        let report = this.state.report;

        let pages = ReportUtil.getAllReportPages(this.state.report);
        let index = -1;
        for (var i=0; i<pages.length; i++) {
            if (pages[i].id == currentReportPage.id) {
                index = i;
                break;
            }
        }
        report.pages.splice(index+1,0,duplicatePage);
        //report.pages.push(duplicatePage);

        ReportUtil.saveReport(this.state.selectedProject.id, report);
        //let project = await GraphUtil.updateReportJson(reportJson, this.state.selectedProject);
        this.loadPagesForProject(this.state.selectedProject.id);
        let analyticsDatasets = this.generateDatasets();
        this.setState({report:report, analyticsDatasets: analyticsDatasets}, function (this: DashboardPage) {
            this.forceUpdate();
        }.bind(this));
    }

    /*onRowSelection(item:GraphSettings, data:any) {
        console.log("onRowSelection");
        console.log(item);
        console.log(data);

        DialogUtil.open(this.selectedValuesDialog.current, {graphSettingItem:item, data:data});
    }*/

    onRowSelection2(data:any, item:GraphSettings, datasets:any) {
        console.log(item);
        console.log(datasets);
        if (item.chartType == "listTable") {
            console.log(data);
            DialogUtil.open(this.selectedValuesDialog.current, {graphSettingItem:item, data:data});

        } else if (typeof data === 'object' && data && data.length > 0) {
            var index = data[0]._index;
            var dataItem = datasets[index];
            console.log(dataItem);
            DialogUtil.open(this.selectedValuesDialog.current, {graphSettingItem:item, data:dataItem});
        }
    }

    resetCustomDates(e:any) {
        this.dateIntervalSelected("lastMonth");
    }

    /*
     * Render methods
     */

    renderHeader() {
        let moreActionsOptions = ["Download", "Duplicate", "Delete", "Data Mapping", "Manage Pages"];
        let cf = this.state.componentFactory;
        let left = cf.renderHorizontalLayout([
            cf.renderBoxProps({marginLeft:'25px'}, cf.renderSelectField("selectedProjectId", null, this.state.projectOptions, null, null, {inputType:"bootstrap"})),
            cf.renderBoxProps({marginLeft:'20px', marginTop:'5px'}, ReportUtil.getCurrentReportPage(this.state.report)?.pageTitle),
            <MenuButtonComponent menuItemLabels={this.state.pageOptions} onTouchTap={this.onPageSelected.bind(this)}><MoreVert color='secondary'/></MenuButtonComponent>,
            cf.renderBoxProps({marginTop:'5px', marginRight:'20px'}, "Showing data for " + DashboardDateUtil.getTimeIntervalString()),
            cf.renderSelectField("dateOptionValue", null, Constants.DATE_OPTIONS, null, null, {inputType:"bootstrap"}),
            this.state.dateOptionValue == "custom" ? cf.renderButton("Reset", this.resetCustomDates.bind(this), {marginLeft:'20px', isFlat:true}) : null,
        ])
        let right = cf.renderHorizontalLayout([
            cf.renderBoxProps({marginTop:'-5px'},
                <IconButtonComponent color="primary" icon={BaseIcon.ICON_SETTINGS} onTouchTap={DialogUtil.openFunction(this.pageSettingsDialog.current, ReportUtil.getCurrentReportPage(this.state.report))}  />,
            ),
            <MenuButtonComponent menuItemLabels={moreActionsOptions} onTouchTap={this.moreActionsTapped.bind(this)}><MoreVert color='secondary'/></MenuButtonComponent>
        ]);
        return (
            cf.renderBoxProps({marginLeft:'80px', marginTop:'20px', backgroundColor:"#ff0000"}, [
                cf.renderRightLeftLayout(left, right),
                cf.renderLine(),
                !this.state.dataLoaded ? <LinearProgress /> : null
            ])
        )
    }

    renderPercentChanged(item:GraphSettings) {
        if (!item.showPercentIncrease) return null;
        let percentChanged = GraphUtil.calculatePercentChange(item, AnalyticsEngine.getData(item, this.state.timeInterval), AnalyticsEngine.getData(item, DashboardDateUtil.getPreviousTimeInterval()));
        if (percentChanged >= 0) {
            return <span className="positivePercent middle-vertical"><img src={arrowUp} style={{marginRight: '3px'}}/>{(Math.round(Math.abs(percentChanged) * 100))}%</span>;
        } else {
            return <span className="negativePercent middle-vertical"><img src={arrowDown} style={{marginRight: '3px'}}/>{(Math.round(Math.abs(percentChanged) * 100))}%</span>;
        }
    }

    renderTextbox() {
        let cf = this.state.componentFactory;
        if (!this.state.dataLoaded) return null;

        let currentReportPage = ReportUtil.getCurrentReportPage(this.state.report);
        let textTypes:Array<GraphSettings> = currentReportPage ? GraphUtil.getTextGraphs(currentReportPage) : [];
        return (
            textTypes && textTypes.length > 0 ?
                cf.renderBoxProps({marginLeft:"90px"}, [
                    <div className="styledWrapper">{textTypes[0].text}</div>
                ]) : null
        )
    }

    renderIndividualSummary(item:GraphSettings, index:number) {
        let graphOptions = ["Data", "Options", "Filter", "Export"];
        return (
            <PaperComponent key={"counters_" + index} className="styledContainer__maxHeight" style={{margin:'10px', textAlign:'left'}}>
                <div className="styledWrapper styledWrapper--stat">
                    <h1 style={{margin:'0px',padding:'5px 10px'}}>
                        <Level style={{margin:'0px', padding:'0px'}}>
                            <Level.Side align="left">
                                <Level.Item>{item.graphTitle ?? AnalyticsTypes.getLabel(item.dataSource) + " " + AnalyticsTypes.getLabel(item.metric)}</Level.Item>
                            </Level.Side>
                            <Level.Side align="right">
                                <Level.Item><MenuButtonComponent menuItemLabels={graphOptions} onTouchTap={((index:number) => this.optionsTapped(item,index)).bind(this)}><MoreVert color='secondary'/></MenuButtonComponent></Level.Item>
                            </Level.Side>
                        </Level>
                        <span style={{margin:'0px', padding:'0px'}} className={`units ${item.graphColor || Constants.DEFAULT_GRAPH_COLOR}`}>{AnalyticsTypes.applyFormat(item, GraphUtil.aggregateDataset(item, this.state.analyticsDatasets[GraphUtil.getGraphKey(item, Constants.CURRENT)]))} {this.renderPercentChanged(item)}</span></h1>
                </div>
            </PaperComponent>)
    }

    renderSummaries() {
        let cf = this.state.componentFactory;
        if (!this.state.dataLoaded) return null;

        let currentReportPage = ReportUtil.getCurrentReportPage(this.state.report);
        let allSummaryTypes:Array<GraphSettings> = currentReportPage ? GraphUtil.getSummaryGraphs(currentReportPage) : [];
        let summaryTypes = [];
        for (let allGraphType of allSummaryTypes) {
            if (!allGraphType.hidden) summaryTypes.push(allGraphType);
        }
        let summaryTypesRow1:Array<GraphSettings> = summaryTypes.slice(0,3);
        let summaryTypesRow2:Array<GraphSettings> = summaryTypes.slice(3,6);

        return (
            cf.renderBoxProps({marginLeft:"90px"}, [
                summaryTypesRow1 ? cf.renderHorizontalLayout(summaryTypesRow1.map((item:GraphSettings, index:number) => this.renderIndividualSummary(item,index)),["33%","33%","33%"]) : null,
                summaryTypesRow2 ? cf.renderHorizontalLayout(summaryTypesRow2.map((item:GraphSettings, index:number) => this.renderIndividualSummary(item,index)),["33%","33%","33%"]) : null,
            ])
        )
    }

    renderIndividualGraph(item:GraphSettings):any {
        //let cf = this.state.componentFactory;
        let graphOptions = ["Data", "Options", "Filter", "Export"];
        let color = item.graphColor || Constants.DEFAULT_GRAPH_COLOR;

        return (
            <PaperComponent key={"paper_" + item.id} style={{margin:'10px'}}>
                <div className="styledWrapper">
                    <Level style={{marginTop:'-10px', marginBottom:item.showStatistics ? '0px' : '15px'}}>
                        <Level.Side align="left">
                            <Level.Item>
                                {DataMappingUtil.replaceData(item.graphTitle && item.graphTitle !== "" ? item.graphTitle : AnalyticsTypes.getLabel(item.dataSource) + " " + AnalyticsTypes.getLabel(item.metric), this.state.dataMappings)}
                            </Level.Item>
                        </Level.Side>
                        <Level.Side align="right">
                            <Level.Item><MenuButtonComponent menuItemLabels={graphOptions} onTouchTap={((index:number) => this.optionsTapped(item,index)).bind(this)}><MoreVert color='secondary'/></MenuButtonComponent></Level.Item>
                        </Level.Side>
                    </Level>

                    { item.showStatistics ? <h2 style={{margin:'5px'}}>{ GraphUtil.getSummaryStats(item, this.state.analyticsDatasets[GraphUtil.getGraphKey(item, Constants.CURRENT)], this.state.timeInterval, color) } </h2> : null }
                    { GraphUtil.getGraph(item, this.state.analyticsDatasets[GraphUtil.getGraphKey(item, Constants.CURRENT)], this.state.timeInterval, color, (data:any) => { this.onRowSelection2(data, item, this.state.analyticsDatasets[GraphUtil.getGraphKey(item, Constants.CURRENT)]) }) }
                </div>
            </PaperComponent>
        );
    }

    renderGraphs() {
        let cf = this.state.componentFactory;
        if (!this.state.dataLoaded) return null;
        //console.log(GraphUtil.getCurrentAnalyticsPage())
        let currentReportPage = ReportUtil.getCurrentReportPage(this.state.report);
        let allGraphTypes:Array<GraphSettings> = currentReportPage ? GraphUtil.getDetailGraphs(currentReportPage) : [];
        let graphTypes = [];
        for (let allGraphType of allGraphTypes) {
            if (!allGraphType.hidden) graphTypes.push(allGraphType);
        }
        let graphTypesRow1:Array<GraphSettings> = graphTypes.slice(0,2);
        let graphTypesRow2:Array<GraphSettings> = graphTypes.slice(2,4);
        let graphTypesRow3:Array<GraphSettings> = graphTypes.slice(4,6);
        //let colors = ["blue", "violet", "green", "blue"];
        //let colors = ["blue", "blue", "blue", "blue"];
        let graph1Row:any[] = [];
        let graph2Row:any[] = [];
        let graph3Row:any[] = [];
        graphTypesRow1.map((item:GraphSettings, index:number) => (
            graph1Row.push(this.renderIndividualGraph(item))
        ))
        graphTypesRow2.map((item:GraphSettings, index:number) => (
            graph2Row.push(this.renderIndividualGraph(item))
        ))
        graphTypesRow3.map((item:GraphSettings, index:number) => (
            graph3Row.push(this.renderIndividualGraph(item))
        ))
        return (
            cf.renderBoxProps(Styles.MARGIN_SIDEBAR,[
                graphTypesRow1 ?
                    cf.renderHorizontalLayout(graph1Row, ["33%","33%","33%"]) : null,

                graphTypesRow2 ?
                    cf.renderHorizontalLayout(graph2Row, ["33%","33%","33%"]) : null,

                graphTypesRow3 ?
                    cf.renderHorizontalLayout(graph3Row, ["33%","33%","33%"]) : null,
            ])
        )
    }

    renderNoProject() {
        return (
            <div className="center-div-contents">
                <img src={analyticsLogo} style={{marginTop:'100px', width:'50px'}} />
                <div>No project set</div>
            </div>
        );
    }

    render() {
        let cf = this.state.componentFactory;
        return (
            cf.renderBoxProps({fullHeight:true, background:BaseColor.WHITE}, [
                this.state.dialogs,
                this.state.selectedProject ?
                    cf.renderBox([
                        this.renderHeader(),
                        this.renderTextbox(),
                        this.renderSummaries(),
                        this.renderGraphs()
                    ])
                    : this.renderNoProject()
            ])
        );
    }
}

export default base(DashboardPage, Sidebar)